<template>
    <div class="z-50 cursor-pointer">
        <div class="relative bg-white hover:bg-gray-100 rounded-lg cursor-pointer">
            <div @click="isOpen = ! isOpen" class="py-2 px-4 flex flex-row items-center stroke-gray-700">
                <span class="p-2 w-8 h-8 border-2 border-blue-400 rounded-full"></span>
                <span class="px-2 text-sm text-gray-800 font-semibold">Radius</span>
            </div>

            <div v-if="isOpen" class="p-5 absolute mt-1 bg-white border border-gray-100 rounded-md shadow-lg z-50" :class="addNewMode ? 'min-w-[500px]' : 'min-w-[450px]'">
                <div class="flex items-center justify-between">
                    <div class="flex items-center space-x-3">
                        <h2 class="text-lg font-bold">Rings</h2>
                        <div v-if="reatlas.circles.length" class="flex justify-center">
                            <button @click="addNewMode = true" class="btn btn-small btn-blue">
                                <div class="flex items-center justify-center space-x-2">
                                    <inline-svg name="add" classes="w-3 h-3 text-white fill-current"></inline-svg>
                                    <p class="text-white text-sm">New Radius Ring</p>
                                </div>
                            </button>
                        </div>
                    </div>
                    <div @click="isOpen = false" class="cursor-pointer">
                        <inline-svg name="close" />
                    </div>
                </div>

                <div class="mt-3">
                    <table v-if="addNewMode || reatlas.circles.length" class="w-full shadow-none">
                        <tbody>
                            <tr v-for="(ring, ringIndex) in sortedCircles" :key="ringIndex">
                                <td class="pl-4">{{ reatlas.layout == 'site' ? ring.marker.building.address_line_1 : ring.marker.address_line_1 }}</td>
                                <td>
                                    <input
                                        :key="ring.marker.building_id"
                                        :data-building="ring.marker.building_id || ring.marker.id"
                                        @input="resizeRing($event)"
                                        v-model="ring.miles"
                                        class="mt-2 max-w-24 range-green"
                                        type="range"
                                        min="5"
                                        max="50"
                                        step="5"
                                    />
                                </td>
                                <td class="mt-1 pl-3 flex items-center">
                                    <span>{{ ring.miles }}</span>
                                    <span class="ml-1">Miles</span>
                                </td>
                                <td class="pl-4">
                                    <button @click="removeRing(ring.marker.building_id)">
                                        <inline-svg name="close" />
                                    </button>
                                </td>
                            </tr>
                            <tr v-if="addNewMode">
                                <td class="pl-4">
                                    <select class="form-select" v-model="newRing.building_id">
                                        <option value=''>Select Building</option>
                                        <template v-if="reatlas.layout == 'site'">
                                            <option v-for="marker in markers" :key="marker.item.building.id" :value="marker.item.building.id">{{ marker.item.building.address_line_1 }}, {{ marker.item.building.city }}, {{ marker.item.building.state }}</option>
                                        </template>
                                        <template v-if="reatlas.layout == 'projects'">
                                            <option v-for="marker in markers" :key="marker.item.id" :value="marker.item.id">{{ marker.item.address_line_1 }}, {{ marker.item.city }}, {{ marker.item.state }}</option>
                                        </template>
                                    </select>
                                </td>
                                <td class="px-4">
                                    <input v-model="newRing.miles" class="mt-2 max-w-24 range-green" type="range" min="5" max="50" step="5" />
                                </td>
                                <td class="mt-3 flex items-center">
                                    <span>{{ newRing.miles }}</span>
                                    <span class="ml-1">Miles</span>
                                </td>
                                <td class="pl-4">
                                    <button @click="createRing" class="mt-1">
                                        <inline-svg name="checkmark" />
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <div v-if="! addNewMode && ! reatlas.circles.length" class="flex justify-center">
                        <button @click="addNewMode = true" class="btn btn-small btn-blue">
                            <div class="flex items-center justify-center space-x-2">
                                <inline-svg name="add" classes="w-4 h-4 text-white fill-current"></inline-svg>
                                <p class="text-white">New Radius Ring</p>
                            </div>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex';

    export default {
        data() {
            return {
                isOpen: false,
                addNewMode: false,
                newRing: {
                    building_id: '',
                    miles: 10,
                    ring: null
                }
            }
        },

        computed: {
            ...mapState(['reatlas']),

            markers() {
                return _.sortBy(_.filter(this.reatlas.markers, marker => {
                    return ['site', 'comp'].includes(marker.type);
                }), marker => {
                    return marker.type == 'site'
                     ? marker.item.building.address_line_1
                     : marker.item.address_line_1
                });
            },

            sortedCircles() {
                return _.sortBy(this.reatlas.circles, circle => {
                    return this.reatlas.layout == 'site' ? circle.marker.building.address_line_1 : circle.marker.address_line_1
                });
            }
        },

        methods: {
            createRing() {
                if (this.newRing.building_id == '') {
                    this.$notify({
                        type: 'error',
                        title: 'Error',
                        text: 'Select a Building'
                    });

                    return;
                }

                let marker = _.find(this.reatlas.markers, marker => {
                    return marker.type == 'site'
                     ? marker.item.building_id == this.newRing.building_id
                     : marker.item.id == this.newRing.building_id
                });

                this.$store.dispatch('drawCircle', {
                    item: marker.item,
                    position: {
                        lat: marker.type == 'site' ? marker.item.building.latitude : marker.item.latitude,
                        lng: marker.type == 'site' ? marker.item.building.longitude : marker.item.longitude
                    },
                    miles: this.newRing.miles
                });

                this.newRing.building_id = '';
                this.newRing.miles = 10;

                this.addNewMode = false;

                this.$notify({
                    type: 'success',
                    title: 'Success',
                    text: 'Radius Ring Created'
                });
            },

            resizeRing(el) {
                let marker = _.find(this.reatlas.markers, marker => {
                    return marker.type == 'site'
                     ? marker.item.building_id == el.target.dataset.building
                     : marker.item.id == el.target.dataset.building
                });

                this.removeRing(marker.item.building_id);

                this.$store.dispatch('drawCircle', {
                    type: marker.type,
                    item: marker.item,
                    position: {
                        lat: marker.type == 'site' ? marker.item.building.latitude : marker.item.latitude,
                        lng:marker.type == 'site' ? marker.item.building.longitude : marker.item.longitude,
                    },
                    miles: parseInt(el.target.value)
                });
            },

            removeRing(forBuildingId) {
                let ring = _.find(this.reatlas.circles, circle => {
                    return circle.marker.building_id == forBuildingId;
                });

                if (ring) {
                    ring.ring.setMap(null);

                    this.reatlas.circles = _.remove(this.reatlas.circles, circle => {
                        return circle.marker.building_id != forBuildingId;
                    });
                }
            }
        }
    }
</script>
